import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .applications-page {
    .applications-area {
      padding: 70px 0;

      .application-box {
        margin-bottom: 30px;

        .application-content {
          position: relative;

          .content-box {
            position: relative;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
            border-radius: 5px;
            background: #ffffff;
            padding: 20px;
          }

          .application-title {
            margin-bottom: 10px;

            h6 {
              margin-bottom: 0;
              a {
                color: ${colors.black1};
                font-weight: 600;
                &:hover {
                  color: ${colors.red};
                }
              }
            }
          }

          .application-info {
            margin-bottom: 12px;
            ul {
              margin-bottom: 0;
              li {
                font-size: 13px;
                color: ${colors.text3};
                margin-right: 18px;
                i {
                  font-size: 18px;
                  color: ${colors.red};
                  margin-right: 6px;
                  vertical-align: top;
                }
              }
            }
          }

          .application-desc {
            p {
              font-size: 13px;
              color: ${colors.text2};
              line-height: 20px;
              margin-bottom: 0;
            }
          }

          .status-block {
            border-left: 1px solid ${colors.border1};
            padding-left: 20px;
            text-align: center;

            .submitted {
              font-size: 12px;
              text-transform: uppercase;
              color: ${colors.text3};
              letter-spacing: 0.5px;
              margin-bottom: 6px;
            }

            .status-pill {
              display: inline-block;
              padding: 6px 14px;
              border-radius: 999px;
              font-size: 12px;
              font-weight: 600;
              background: rgba(18, 173, 91, 0.12);
              color: ${colors.red};
              margin-bottom: 12px;
            }

            .action-btn {
              a {
                font-size: 12px;
                color: ${colors.black2};
                border: 1px solid ${colors.border3};
                font-weight: 500;
                text-transform: uppercase;
                padding: 9px 12px 7px;
                border-radius: 5px;
                display: inline-block;
                &:hover {
                  color: #ffffff;
                  background: ${colors.red_bg};
                  border-color: ${colors.red};
                }
              }
            }
          }

          @media (max-width: 991px) {
            .status-block {
              border-left: none;
              margin-top: 20px;
              padding-left: 0;
            }
          }
        }
      }

      @media (max-width: 767px) {
        padding: 40px 0 35px;
      }
    }
  }
`;
